import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@context/AuthContext";

const UnauthenticatedRoute: React.FC = () => {
  const { isAuthenticated, role } = useAuth();

  if (isAuthenticated) {
    // Redirect to dashboard based on the user's role
    const dashboardPath =
      role === "admin" ? "/admin/dashboard" : "/user/dashboard";
    return <Navigate to={dashboardPath} replace />;
  }

  return <Outlet />;
};

export default UnauthenticatedRoute;
